import { apiFetch } from '../../utils/api';

export function readWorkspaceSettings(value) {
  if (!value || !['focus', 'classic'].includes(value.activeInterface) ||
      !['focus', 'classic'].includes(value.defaultInterface) || typeof value.focusAvailable !== 'boolean' ||
      ![null, 'focus', 'classic'].includes(value.preference)) throw new Error('Could not confirm your workspace preference.');
  return value;
}

export const workspaceClient = {
  async get(signal) {
    return readWorkspaceSettings(await apiFetch('/api/user/workspace', { signal, cache: 'no-store' }));
  },
  async save(workspaceInterface) {
    return readWorkspaceSettings(await apiFetch('/api/user/workspace', { method: 'PATCH', body: { workspaceInterface } }));
  },
};

export function workspacePath(location, destination) {
  const root = destination === 'classic' ? '/dashboard' : '/focus';
  const suffix = location.pathname.replace(/^\/(?:focus|dashboard)(?=\/|$)/, '');
  const shared = /^(?:\/(?:tasks|calendar|teams|org-invites|integrations|profile|settings|reports|intelligence|command-center|billing)|\/meetings(?:\/[^/]+)?|\/projects(?:\/[^/]+(?:\/edit)?)?|\/inbox(?:\/[^/]+\/[^/]+)?)?\/?$/;
  if (!/^\/(?:focus|dashboard)(?:\/|$)/.test(location.pathname) || !shared.test(suffix)) return root;
  return `${root}${suffix}${location.search || ''}${location.hash || ''}`;
}

export const WORKSPACE_LEAVE_CHECK = 'inboxops:workspace-leave-check';
export function workspaceLeaveState() {
  const detail = { dirty: false, busy: false };
  window.dispatchEvent(new CustomEvent(WORKSPACE_LEAVE_CHECK, { detail }));
  return detail;
}
